/*
 * Where: src/components/organisms/SiteFooter.js
 * What: Organism component for global footer.
 * Why: Share bottom information across multiple pages.
 */
import React from 'react';

function SiteFooter() {
    return (
        <footer className="site-footer">
            <div className="container footer-inner">
                <p>行政支援レコメンドデモ（確認専用）</p>
                <p>申請処理は含みません。受給候補の確認のみ対応します。</p>
            </div>
        </footer>
    );
}

export default SiteFooter;
